import React, { Component } from 'react';
export default class SurveyRect extends Component {

	render() {
		const{H, opacity} = this.props
		// const {style} = this.props		
		return <div id="survey_rect" style={{
			position:"absolute",
			right:10,
			left:10,
			bottom:10,
			height:H,
			border:"2px solid black",
			borderRadius:8,
			backgroundColor:`rgba(255,255,255,${opacity !== undefined? opacity : 0.925})`,
						
		}}>
			{this.props.children}
	  	</div>
	}
}



// WEBPACK FOOTER //
// ./src/Comp/Shared/SurveyRect.js